import { Component, ElementRef, Input, OnInit } from '@angular/core';


@Component({
  selector: 'prism-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent implements OnInit{

  @Input() slow: boolean = false;
  @Input() strokeOpacity: number = 0.75;


  constructor(
    private elementRef: ElementRef,
  ) { }

  ngOnInit(): void {
    const hostElement = this.elementRef.nativeElement;
    hostElement.style.setProperty('--stroke-opacity', this.strokeOpacity.toString());

    if (this.slow) {
      // Slow durations
      hostElement.style.setProperty('--outer-speed', '30s');
      hostElement.style.setProperty('--middle-speed', '20s');
      hostElement.style.setProperty('--inner-speed', '10s');
    } else {
      // Fast durations
      hostElement.style.setProperty('--outer-speed', '3.5s');
      hostElement.style.setProperty('--middle-speed', '2.5s');
      hostElement.style.setProperty('--inner-speed', '1.5s');
    }
  }


}
